module.exports = __webpack_public_path__ + "img/Me-01.c68368cf.jpg";